import { render } from "./HeaderMcCain.vue?vue&type=template&id=80094b8a"
import script from "./HeaderMcCain.vue?vue&type=script&lang=js"
export * from "./HeaderMcCain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__